import Hero from '@/pages/home/components/Hero';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import FeaturedFigures from '@/pages/home/components/FeaturedFigures';
import LatestTopics from '@/pages/home/components/LatestTopics';
import TimelineSection from '@/pages/home/components/TimelineSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaSection from '@/pages/home/components/CtaSection';
import { siteName } from '@/mocks/site';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: siteName,
      url: 'https://hnitsc.cn/',
      inLanguage: 'zh-CN',
      description:
        '独家黑料档案中心收录人物库与历史记录，深挖旧事背景与秘史脉络，补全碎片化信息。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://hnitsc.cn/topics?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: siteName,
      url: 'https://hnitsc.cn/',
      email: 'archive@heiliao-archive.com',
      description: '以公开可核对材料整理人物档案与历史记录的独立档案中心。',
    },
    {
      '@type': 'WebPage',
      name: '独家黑料档案中心｜人物库·历史记录·秘史背景深挖',
      url: 'https://hnitsc.cn/',
      inLanguage: 'zh-CN',
      isPartOf: { '@type': 'WebSite', name: siteName },
    },
  ],
};

export default function Home() {
  return (
    <>
      <Hero />
      <CategoryGrid />
      <FeaturedFigures />
      <LatestTopics />
      <TimelineSection />
      <FaqSection />
      <CtaSection />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
    </>
  );
}